import { InteractiveCopyField } from '@pinwheel/origami';
import React from 'react';
import { useSelector } from 'react-redux';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { selectBankInfosForManualInstructions } from '../../state/slices/slice-link-api';
var AccountAndRoutingNumberDisplay = function () {
    var getLocalizedString = useGetLocalizedString();
    var bankInfos = useSelector(selectBankInfosForManualInstructions);
    if (!bankInfos || bankInfos.length === 0) {
        return null;
    }
    return (React.createElement("div", { "data-testid": "AccountAndRoutingNumberDisplay" },
        React.createElement(InteractiveCopyField, { label: getLocalizedString('ROUTING'), value: bankInfos[0].routingNumber }),
        React.createElement(InteractiveCopyField, { label: getLocalizedString('ACCOUNT'), value: bankInfos[0].accountNumber })));
};
export default AccountAndRoutingNumberDisplay;
